import React from 'react';

class TextSegment extends React.Component {
  render() {
    return (<span className={"HtmlCompare-"+this.props.style} title={this.props.was}>{this.props.slice}</span>);
  }
}

export default TextSegment;
